import Scene from '../classes/scene';

const scene = (state = new Scene({}), action) => {
  switch (action.type) {
    case 'INITIALIZE_SCENE':
      return action.scene;
    case 'SET_TRAIL_LENGTH': {
      const settings = {
        ...state.sceneSettings,
        trailLength: action.trailLength,
      };
      return {
        ...state,
        sceneSettings: settings,
      };
    }
    default:
      return state;
  }
};

export default scene;
